export default "__VITE_ASSET__D7aM4SPi__"